<template>
    <div v-if="props.manual" class="ap-manual-link">
        <ApContentToolTip placement="right" :message="$t('common.userGuide')">
             <div v-html="props.manual" />
        </ApContentToolTip> 
    </div>
</template>

<script setup>
    import { ApContentToolTip } from '@ap/ap-plugin-tooltip'

    const props = defineProps({
        manual: String
        })
</script>

<style lang="scss">
    .ap-manual-link {
        background-image: url('~icons/question.svg');
        background-repeat: no-repeat;
        background-position: 0px 0px;
        display: inline-block;
        top: 10px;
        left: 5px;
        cursor: pointer;
        position: relative;
        background-size: 18px auto;
        width: 18px;
        height: 18px;

        &:hover {
            background-image: url('~icons/question-hover.svg');
        }

        a {
            display: inline-block;
            width:18px;
            height:18px;
        }
    }
</style>